/**
 * @phxBrowserDetect
 */
import { EABError } from 'core-js-error';

export class phxBrowserDetectController {
  private _configuredBrowsers: string[];
  private _incompatableBrowsers: string[];
  showMessage: boolean = false;
  constructor(private $attrs: ng.IAttributes, private ngBrowserDetectDelegate: phxBrowserDetectDelegate) {}
  $onInit(): void {
    this._configuredBrowsers = this.ngBrowserDetectDelegate.allConfiguredBrowsers();
    this._incompatableBrowsers = _.intersection(this._configuredBrowsers, Object.keys(this.$attrs.$attr));
    this._showMessage();
  }

  private _showMessage(): void {
    this.showMessage = _.some(this._incompatableBrowsers, (browserName: string) =>
      this.ngBrowserDetectDelegate.isBrowser(browserName)
    );
  }
}

export class phxBrowserDetectDelegate {
  private _userAgent: string = window.navigator.userAgent;
  private _result: boolean = false;
  isBrowser(browserName: string): boolean {
    switch (browserName) {
      case 'chrome':
        this._result = /chrome|crios|crmo/i.test(this._userAgent) ? true : false;
        break;
      case 'firefox':
        this._result = /firefox|iceweasel|fxios/i.test(this._userAgent) ? true : false;
        break;
      case 'safari':
        this._result =
          /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
          !/chrome|crios|crmo|firefox|iceweasel|fxios/i.test(navigator.userAgent)
            ? true
            : false;
        break;
      case 'msie':
        this._result = /msie|trident/i.test(this._userAgent) ? true : false;
        break;
      case 'msedge':
        this._result = /chrome.+? edge/i.test(this._userAgent) ? true : false;
        break;
      case 'opera':
        this._result = /opera/i.test(this._userAgent) || /opr|opios/i.test(this._userAgent) ? true : false;
        break;
      default:
        this._result = this._result;
    }
    return this._result;
  }
  allConfiguredBrowsers(): string[] {
    return ['chrome', 'firefox', 'safari', 'opera', 'msie', 'msedge'];
  }

  getBrowserName(): string {
    if (/chrome|crios|crmo/i.test(this._userAgent)) {
      return 'Chrome';
    } else if (/firefox|iceweasel|fxios/i.test(this._userAgent)) {
      return 'Firefox';
    } else if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      return 'Safari';
    } else if (/msie|trident/i.test(this._userAgent)) {
      return 'Internet Explorer';
    } else if (/chrome.+? edge/i.test(this._userAgent)) {
      return 'Edge';
    } else if (/opera/i.test(this._userAgent) || /opr|opios/i.test(this._userAgent)) {
      return 'Opera';
    } else {
      return '';
    }
  }
}

angular
  .module('ui-ng-browser-detect', [])
  .controller('ngphxBrowserDetectController', phxBrowserDetectController)
  .service('ngBrowserDetectDelegate', phxBrowserDetectDelegate)
  .component('phxBrowserDetect', {
    transclude: true,
    templateUrl: 'ui-ng-browser-detect/src/templates/phx-browser-detect.html',
    controller: 'ngphxBrowserDetectController',
    controllerAs: '$ctrl'
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-browser-detect/src/main.ts